/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { FilterPress } from "./modelFilterPress";

class ControllerFilterPress extends ControllerModel {
    constructor() {
        super("ControllerFilterPress");

        this.setNewNode = (callback) => {
            let filterPress = new FilterPress();
            filterPress.decorate(callback);

            this.addNode(filterPress);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let filterPress = new FilterPress();
            filterPress.copyFrom(node);
            filterPress.decorate(callback);
            this.addNode(filterPress)
        }

        this.getProperties = async (node) => {
            let n = new FilterPress();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new FilterPress();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerFilterPress };